import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { CheckListComponentModule } from 'app/components/check-list/check-list.module';
import { UserSelectionComponent } from './user-selection/user-selection.component';
import { UserSelectionDialogComponent } from './user-selection-dialog/user-selection-dialog.component';

@NgModule({
    declarations: [
        UserSelectionComponent,
        UserSelectionDialogComponent,
    ],
    imports: [
        FuseWidgetModule,
        FuseSharedModule,
        CommonModule,
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        FormsModule,
        MatIconModule,
        MatToolbarModule,
        MatDividerModule,
        MatDialogModule,
        CheckListComponentModule,
    ],
    exports: [
        UserSelectionComponent,
    ],
    providers: []
})
export class UserComponentsModule {}
